import React, { useState } from "react";
import { Button, Col, Row, Select } from "antd";
import style from "./index.module.scss";
import Form from "rc-field-form";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";
import {
    CurrentTermType,
    getCourseListByTeacher,
    SearchParams
} from "service/answerStore";
import classNames from "classnames";
import useRequest from "utils/useRequest";

interface TopOperationsProps {
    onFinish: (val: SearchParams) => void;
}

export default function TopOperations({ onFinish }: TopOperationsProps) {
    const { Option } = Select;
    const [form] = Form.useForm<SearchParams>();

    const batchList = useAtomValue(termListAtom);
    const [batchNo, setBatchNo] = useState<string[]>([]);

    const [courseList] = useRequest(() => getCourseListByTeacher(batchNo), {}, [
        batchNo
    ]); //动态获取课程列表

    // 提交表单
    const handleFinish = (item: SearchParams) => {
        onFinish(item);
    };

    return (
        <Form form={form} onFinish={handleFinish} className={style.root}>
            <Row>
                <Col span={3} style={{ lineHeight: "32px" }}>
                    选择学期
                </Col>
                <Col span={20}>
                    <Form.Field name="batchNo" initialValue={[]}>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择学期"
                            maxTagCount={2}
                            onChange={(val: string[]) => setBatchNo([...val])}>
                            {batchList.map(item => (
                                <Option
                                    className={classNames({
                                        [style.option]:
                                            item.isCurrentTerm ===
                                            CurrentTermType.isCurrent
                                    })}
                                    value={item.batchNo}
                                    key={item.batchNo}>
                                    {item.batchName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Field>
                </Col>
            </Row>

            <Row>
                <Col span={3} style={{ lineHeight: "32px" }}>
                    选择课程
                </Col>
                <Col span={20}>
                    <Form.Field name="courseNo" initialValue={[]}>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择课程"
                            maxTagCount={2}>
                            {courseList &&
                                courseList.map(item => (
                                    <Option
                                        value={item.courseNo}
                                        key={item.courseNo}>
                                        [{item.courseNo}] {item.courseName}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Field>
                </Col>
            </Row>

            <Row>
                <Col span={3} style={{ lineHeight: "32px" }}>
                    选择分类
                </Col>
                <Col span={20}>
                    <Form.Field name="paperType" initialValue={[]}>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择类别">
                            <Option value="0" key="0">
                                练习
                            </Option>
                            <Option value="1" key="1">
                                作业
                            </Option>
                            <Option value="2" key="2">
                                考试
                            </Option>
                        </Select>
                    </Form.Field>
                </Col>
            </Row>

            <div className={style.btn}>
                <Button type="primary" icon="search" onClick={form.submit}>
                    查询
                </Button>
            </div>
        </Form>
    );
}
